
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./MediaApp";
import { ImageProvider } from "./context/ImageContext";



const initMediaTab = () => {

	const getNewMediaTabObject = (FrameSelect) => {
		return {
			initialize: function () {
				FrameSelect.prototype.initialize.apply(this, arguments);

				var CustomState = wp.media.controller.State.extend({
					insert: function () {
						this.frame.close();
					},
				});

				this.states.add([
					new CustomState({
						id: "image-hub-media-modal-tab",
						search: false,
						title: "Image Hub",
					}),
				]);
				let self = this;

				this.on("content:render:ihmlt", this.renderContent, this);

				//Remove select Button and Toolbar from the image hub tab
				this.on("content:render", function () {
					// Wait for next tick so DOM is rendered
					setTimeout(() => {
						console.log('content:render', jQuery('.media-frame-router>.media-router>.media-menu-item.active')[0]?.innerText);
						if (jQuery('.media-frame-router>.media-router>.media-menu-item.active')[0]?.innerText === 'Image Hub') {
							jQuery('.media-frame-toolbar')?.hide();
						} else {
							jQuery('.media-frame-toolbar')?.show();
						}
					}, 1);
				}, this);



				const onReInsertBrowserButtonIfNeeded = () => {
					const node = self?.$el?.[0];
					if (!node) {
						return;
					}
					let browserButton = node.querySelector('button.browser');
					if (browserButton) {
						return;
					}
					browserButton = document.createElement('button');

					const buttonParent = node.querySelector('.upload-ui');
					if (!buttonParent) {
						return;
					}

					buttonParent.appendChild(browserButton);

					browserButton.outerHTML =
						'<button type="button" class="browser button button-hero" style="position: relative; z-index: 1;" id="__wp-uploader-id-1" aria-labelledby="__wp-uploader-id-1 post-upload-info">Select Files</button>';
				};
				this.on('ready', onReInsertBrowserButtonIfNeeded);


				this.on('router:create:browse', function (routerView) {
					imageHubInsertIconToTabTitle(routerView, self)
				});
			},

			browseRouter: function (routerView) {
				FrameSelect.prototype.browseRouter.apply(this, arguments);

				routerView.set({
					ihmlt: {
						id: "image-hub",
						text: "Image Hub",
						priority: 120,
					},
				});
			},
			renderContent() {
				(renderTabContent.bind(this))();
			},

		}
	}

	var MediaFrameSelect = wp.media.view.MediaFrame.Select;
	wp.media.view.MediaFrame.Select = MediaFrameSelect.extend(getNewMediaTabObject(MediaFrameSelect));

	var MediaFramePost = wp.media.view.MediaFrame.Post;

	wp.media.view.MediaFrame.Post = MediaFramePost.extend(getNewMediaTabObject(MediaFramePost));

	top.imageHubMediaTabInited = true;
}

function renderTabContent() {
	const CustomView = wp.media.View.extend({
		tagName: 'div',
		className: 'demo-image-hub-media-modal-tab',
		render() {
			renderHTMLContent(this.el); // Inject your custom content
			return this;
		},
	});

	const view = new CustomView();
	this.content.set(view);
}
function renderHTMLContent() {
	setTimeout(() => {
		let mediaLibraryRoot = document.querySelector('.demo-image-hub-media-modal-tab');
		if(!mediaLibraryRoot) {
			return;
		}

		const rootDiv = document.createElement('div');
		rootDiv.setAttribute('id', 'demo-image-hub-media-modal-root');
		mediaLibraryRoot.appendChild(rootDiv);
		imageHubMediaTabReactApp(rootDiv)
	}, 10)
}

function imageHubInsertIconToTabTitle(routerView, self) {

	// Wait for next tick so DOM is rendered
	setTimeout(() => {
		const onSelectBrowseButtonIfImageHubActive = ({
			parentNode,
			imageHubTabNode,
		}) => {
			if (imageHubTabNode.classList.contains('active') && parentNode) {
				const browseButton =
					parentNode.querySelector('#menu-item-browse');
				if (browseButton) {
					browseButton.click();
				}
			}
		};

		let libraryType = self?.options?.library?.type?.[0] || 'image';

		let hasVideoTextInButton = self?.options?.button?.text?.includes?.('video');
		if (hasVideoTextInButton) {
			libraryType = 'video'
		}
		const isImage = libraryType === 'image';

		const node = routerView?.view?.$el?.[0];
		if (!node) {
			return;
		}
		const imageHubTabNode =
			node.querySelector('#menu-item-ihmlt');
		if (!imageHubTabNode) {
			return;
		}

		imageHubTabNode.setAttribute(
			'data-type',
			libraryType
		);
		if (!isImage) {
			onSelectBrowseButtonIfImageHubActive({
				imageHubTabNode,
				parentNode: node,
			});
			return;
		}

		const shouldOpenImageHubTab =
			top.kubioOpenImageHubOnNextOpenedMediaPicker;
		top.kubioOpenImageHubOnNextOpenedMediaPicker = false;
		if (shouldOpenImageHubTab) {
			imageHubTabNode.click();
		} else {
			//if the media picker is opened and the active tab is image hub but the free
			//images was not used pick the media library
			onSelectBrowseButtonIfImageHubActive({
				imageHubTabNode,
				parentNode: node,
			});

		}
		const svgParent = document.createElement('div');

		svgParent.innerHTML = `<img height="20px" width="20px" src="${image_hub_data.imageUrl}" alt="Image Hub">`;
		imageHubTabNode.style.display = "flex"
		imageHubTabNode.style.gap = ".5em"
		imageHubTabNode.prepend(svgParent);
	}, 10);
}

const imageHubMediaTabReactApp = (rootElement) => {

	if (!rootElement) {
		return;
	}
	const reactRoot = createRoot(rootElement);
	reactRoot.render(
		<React.StrictMode>
			<ImageProvider>
				<App />
			</ImageProvider>
		</React.StrictMode>,
	);
}

//if the tab is not initiated from kubio then we add the media tab logic.
//The imageHubMediaTabInited flag will be set only until the image hub plugin is installed. After that it won't
if (!top.imageHubMediaTabInited) {
	initMediaTab();
}

top.imageHubMediaTabReactApp = imageHubMediaTabReactApp;

